<template>
  <div>
    <div class="app__header">
      <!-- left: back button (absent on the dashboard) -->
      <div v-if="$route.path !== '/dashboard'" class="app__header-back">
        <v-btn
          fab icon small
          :color="isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.54)'"
          @click="goBack"
        >
          <v-icon>mdi-arrow-left-bold</v-icon>
        </v-btn>
      </div>

      <!-- logo + host -->
      <div class="app__header-brand" @click="navigateToDashboard">
        <v-img contain :src="logoSrc" class="app__header-logo"></v-img>
        <p class="orange--text mb-0 font-weight-bold text-body-2 app__header-host">{{ getAppHost }}</p>
      </div>

      <!-- right: running timer + actions -->
      <div class="app__header-actions">
        <timer v-if="isAuthenticated && $route.path !== '/stemp'"></timer>
        <v-btn icon @click="refreshContentUpdate()">
          <v-icon large>mdi-refresh-circle</v-icon>
        </v-btn>
        <router-link v-if="checkFeatureEnabled('tasks')" to="/tasks" class="app__header-tasks">
          <v-badge :content="tasksCount" overlap>
            <v-icon size="30">mdi-calendar-check</v-icon>
          </v-badge>
        </router-link>
      </div>
    </div>
    <v-divider class="mx-1 grey darken-1"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FeaturesMixin from '@/mixins/features_list'
export default {
  mixins: [FeaturesMixin],
  data () {
    return {
      logoUrl: process.env.VUE_APP_LOGO_FILE_NAME,
      tasksCount: 'test'
    }
  },
  components: {
    timer: () => import('../components/NavbarTimer')
  },
  created () {
    this.tasksCount = window.localStorage.getItem(process.env.VUE_APP_TASKS_COUNT) || '0'
    // this.tasksCount = this.$cookie.get(process.env.VUE_APP_TASKS_COUNT) || '0'
  },
  methods: {
    navigateToDashboard () {
      if (this.$route.path !== '/dashboard') this.$router.push('/dashboard')
    },
    goBack () {
      const path = this.$route.path
      if (['/equipments', '/buildings', '/timer'].includes(path)) this.$router.push('/dashboard')
      else this.$router.go(-1) // this.$eventBus.$emit('goToPreviousPage')
    },
    refreshContentUpdate () {
      if (this.getNewContentAvailable) {
        this.$store.dispatch('reloadNewContent')
      } else {
        this.$router.go()
      }
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'timerData', 'getNewContentAvailable']),
    // follows the global app theme
    isDark () {
      return this.$vuetify.theme.dark
    },
    // Swap to the dark logo when the app is in dark mode, else the configured logo.
    logoSrc () {
      return this.isDark
        ? require('../assets/darkmode_logo.png')
        : require(`../assets/${this.logoUrl}`)
    },
    getAppHost () {
      return this.$cookie.get('WelditPwa_host-ref')
    }
  }
}
</script>
<style scoped>
.app__header{
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  min-height: 56px;
  position: relative;
}
.app__header-back{
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
/* brand takes the slack and is the first thing allowed to shrink */
.app__header-brand{
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 250px;
  cursor: pointer;
}
/* phone baseline; scaled up at the breakpoints below */
.app__header-logo{
  height: 36px;
  width: 100%;
  max-width: 250px;
}

/* centred so it tracks the logo artwork, which `contain` centres in its box */
.app__header-host{
  width: 100%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.1;
}
/* actions keep their intrinsic width so the timer can never be overlapped */
.app__header-actions{
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 6px;
}
.app__header-tasks{
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  padding: 0 6px 0 0;
}
@media only screen and (max-width: 480px){
  .app__header{
    gap: 4px;
    padding: 4px;
  }
}

/* Tablet and desktop: true-centre the brand against the header itself.
   Absolute (not flex) centring, so a running timer widening the right-hand
   actions can't drag the logo off-centre. There is ample room at this width,
   so overlap isn't a risk the way it is on phones. */
@media only screen and (min-width: 600px){
  .app__header{
    min-height: 72px;
  }
  .app__header-brand{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    flex: 0 0 auto;
    width: 230px;
    max-width: 40%;
  }
  .app__header-logo{
    height: 52px;
    max-width: none;
  }
  .app__header-host{
    font-size: 0.9rem !important;
  }
  /* keep the flex row's height driven by the actions, not the absolute brand */
  .app__header-actions{
    margin-left: auto;
  }
}
/* desktop: larger again */
@media only screen and (min-width: 1024px){
  .app__header{
    min-height: 84px;
  }
  .app__header-brand{
    width: 280px;
  }
  .app__header-logo{
    height: 62px;
  }
  .app__header-host{
    font-size: 1rem !important;
  }
}
</style>
